module.exports = __webpack_public_path__ + "3ec395aaeec31baa4d9fbc1e2a7257df.svg";